module.exports = __webpack_public_path__ + "media/one_wish_inst.1b6a386d.mp3";